import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import EventEmitter from 'react-native-md5'
import 'bootstrap/dist/css/bootstrap.min.css'
import _ from 'lodash'

const tableStyle = {
  backgroundColor: '#ffffff',
}

const divStyle = {
  paddingTop: '30px',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
    if (_.size(props.log) > 0) {
      this.state = {
        log: props.log,
      }
    }
  }

  renderHeader() {
    return <Fragment><th key="date">Date & Time</th><th key="author">Author</th><th key="action">Action</th><th key="desc">Description</th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.state.log.logs)).sort((a, b) => b['activity_date'].localeCompare(a['activity_date']))
    return Object.keys(myData).map((key) => {
      const act = myData[key]
      return <tr key={key}><td>{act['activity_date_d']}<br />{act['activity_date_t']}</td><td>{act['user_name']}</td><td>{act['activity']}</td><td dangerouslySetInnerHTML={{__html: act['description']}}></td></tr>
    }
    )
  }

  render() {
    //const myData = [].concat(Object.values(this.state.emp)).find(element => element.user_request === true)
    if (this.state.log) {
      if (this.state.log.req_admin === true) {
        return <div className="row justify-content-center align-items-center" style={divStyle}><table className="table table-bordered" style={tableStyle}><col width="15%"></col><col width="15%"></col><col width="15%"></col><col width="55%"></col><tbody><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table></div>
      } else {
        return <div className="row justify-content-center align-items-center" style={divStyle}>You do not have access to activity log! Only admins can see this!</div>
      }
    }
    return <div className="row justify-content-center align-items-center" style={divStyle}>Loading</div>
  }
}

Table.propTypes = {
  log: PropTypes.object,
}

export default Table
